import { SessionState } from './state';

export const getters = {
  getFilters: (state: SessionState) => name => {
    if (name in state.filtersMap) {
      return state.filtersMap[name];
    }
  },
  getAdvancedSearchVisible: (state: SessionState) => name => {
    if (name in state.advancedSearchVisibleMap) {
      return state.advancedSearchVisibleMap[name];
    }
  },
  getTableOptions: (state: SessionState) => name => {
    if (name in state.tableOptionsMap) {
      return state.tableOptionsMap[name];
    }
  },
  getCachedChoice: (state: SessionState) => name => {
    if (name in state.choiceCache) {
      return state.choiceCache[name];
    }
  },
  getSelectedItem: (state: SessionState) => {
    return state.selectedItem;
  },
  getProjectStatusId: (state: SessionState) => () => {
    return state.projectStatusId;
  },
  getOrderDocEventId: (state: SessionState) => () => {
    return state.orderDocEventId;
  }
};
